import Component from '../components/common/Component';
import { useParams } from 'react-router-dom';

import View from '../components/common/View';

export default function LinkView() {
  const params = useParams()
  return(
		<>
      <View name={params.linkName} from='linkView'/>
      <Component component='conversation'/>
      <Component component='footer'/>
		</>
	)
}